var map = {
	"./en/index.ts": 694,
	"./it/index.ts": 714
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 693;



//////////////////
// WEBPACK FOOTER
// ./src/dashboard/app/core/translate/translations ^\.\/.*\/index\.ts$
// module id = 693
// module chunks = 0